import { getRedirectState } from "../../@api/config";
import {
  getAccessToken,
  getIsPasswordInvalid,
  getIsUserLoading,
  getIsVerifyPasswordInvalid,
  getResourceOwner,
} from "../auth";
import type { RootState } from "../rootReducer";

export const getIsPasswordResetDisabled = (state: RootState): boolean =>
  getIsUserLoading(state) ||
  getIsPasswordInvalid(state) ||
  getIsVerifyPasswordInvalid(state);

export function getSignupLoginValues(state: RootState): OtpLoginSuccessValues {
  return {
    access_token: getAccessToken(state),
    resource_owner: getResourceOwner(state),
    state: getRedirectState(),
  };
}

interface OtpLoginSuccessValues {
  state: string;
  access_token: string;
  resource_owner: string;
}
